module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_6.62399028.jpg";